import { Pipe, PipeTransform } from '@angular/core';
import { KeyValuePipe } from '@angular/common';

@Pipe({
    name: 'stepfilter',
    pure: false
})
export class StepFilterPipe implements PipeTransform {

    constructor(private keyValuePipe: KeyValuePipe) {
    }
    transform(steps: any[], filter: any): any {
        if (!steps || !filter) {
            return steps;
        }
        var tempSteps = [];
        for (var stepKey in steps) {
            var items = [];
            items = this.keyValuePipe.transform(steps[stepKey].Controls);
            items = items.filter(item => item.value.Text.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
            if (items.length > 0) tempSteps.push(steps[stepKey]);
        }
        return tempSteps;
    }
}